const e=e=>e.name??e.email,t=t=>e(t).charAt(0).toUpperCase();export{e as getUserDisplayName,t as getUserInitial};
//# sourceMappingURL=user-display.mjs.map